/** README
 *  该模块管理项目中，所有【电站】的接口请求
 *  >>> 电站信息
 *  >>> 电站拓扑
 * 
 *  注意：
 *      >>> 为方便维护，在业务中尽量通过index文件中提供的，【接口名称】或【接口模块别名】与服务端交互
 * 
 */


import { httpBus } from "@/api/index.js";
export * as topoApi from "./topo.js";



/**
 * 获取电站规模
 * @param {*} stationId 
 * @returns 
 */
export function getStationScale(stationId) {
  return httpBus.request("get", `/device/v2/station/data`, {
    params: { stationId }
  });
}


/**
 * 获取系统效率Top10的电站
 * @returns 
 */
export function getTop10Stations() {
  return httpBus.request("get", `/device/v2/station/top`);
}


/**
 * 获取电站的运行评价
 * @returns 
 */
export function getScoreCount() {
  return httpBus.request("get", `/dashboard/ops/report/station/score/count`);
}


/**
 * 获取所有电站的月储能收益分析结果
 * @param {*} startTime 
 * @param {*} endTime 
 * @returns 
 */
export function getIncomeResByMonth(startTime, endTime) {
  const params =  { startTime, endTime };
  return httpBus.request(
    "get",
    `/dashboard/dataAnalysis/stations/monthIncomeAndPower`,
    { params }
  );
}


/**
 * 获取电站的-节能减排
 * @param {*} stationId 
 * @returns 
 */
export function getConserveEnergyResultData(stationId) {
  const params = Object.assign({}, { stationId });
  return httpBus.request("get", `/dashboard/dataAnalysis/stations/energy`, {
    params: params
  });
}

/**
 * 获取内部收益率IRR
 */
export function getIRR() {
  return httpBus.request("get", `/dashboard/irr/list`);
}


/**
 * 新增电站基本信息
 * @returns 
 */
export function add(station) {
  return httpBus.request("post", `/device/station`, { data: station });
}


/**
 * 修改电站基本信息
 * @returns 
 */
export function update(station) {
  return httpBus.request("put", `/device/station`, { data: station });
}


/**
 * 删除电站基本信息
 * @returns 
 */
export function del(stationIds) {
  return httpBus.request("delete", `/device/station/${stationIds}`);
}

/**
 * 获取电站列表
 * @param {*} param 
 * >>> pageNum: 1,
 * >>> pageSize: 9999,
 * @returns 
 */
export function list(param) {
  return httpBus.request("get", `/device/station/list`, { params: param });
}

/**
 * 获取电站基本信息详细信息
 * @returns 
 */
export function detail(stationId) {
  return httpBus.request("get", `/device/station/${stationId}`);
}

/**
 * 获取电站名称列表
 * @returns 
 */
export function nameList() {
  return httpBus.request("get", `/device/station/queryNameList`);
}

/**
 * 导入
 * @returns 
 */
export function importList(params) {
  return httpBus.request("post", `/device/station/importData`, { data: params });
}

/**
 * 导出
 * @returns 
 */
export function exportList(params) {
  return httpBus.request("get", `/device/station/export`, { params: params });
}


/**
 * 上传电站图片
 * @returns 
 */
export function uploadImage(params) {
  return httpBus.request("post", `/device/station/upload`, { data: params });
}

/**
 * 电站退役
 * @returns 
 */
export function changeStationState(stationIds) {
  return httpBus.request("get", `/device/station/changeStationState/${stationIds}`);
}

/**
 * 获得模板详情
 * @returns 
 */
export function getTemplateList() {
  return httpBus.request("get", `/productmng/template/list`);
}



/**
 * 导出资产模板
 * @returns
 */
// export function downloadTemplate() {
//   window.open(`http://${API_HOST}/common/downloadTemplate`)
// }


/**
 * 导入资产数据
 * @returns 
 */
export function importAssets(file, onUploadProgress) {
  const fd = new FormData()
  fd.append('file', file, file.name)
  // fd.append('updateSupport', false)
  return httpBus.request("post", `/device/station/importStations`, { data: fd });
}


/**
 * 导出资产数据
 * @returns 
 */
export function exportAssets(stations, sheets, exportAll,) {
  return httpBus.request("get", `/device/station/exportStations`, {
    data: {
      stations,
      sheets,
      exportAll
    }
  });
}

// v2
// ============================================================================
// ============================================================================

/**
 * 查询电站下的设备
 * @returns 
 */
export function getDevicesById(stationId) {
  return httpBus.request("get", `/device/v2/station/equipments/${stationId}`);
}



/**
 * 查询电站下的设备
 * @returns 
 */
export function getDevicesByIdV2(stationId) {
  return httpBus.request("get", `/device/v2/station/new/equipments/${stationId}`);
}

/**
 * 注册设备
 * @returns 
 */
export function registerDevices(devices) {
  return httpBus.request("put", `/device/v2/station/equipment`, { data: devices });
}

/**
 * 注册设备2
 * @returns 
 */
export function registerDevicesV2(devices) {
  return httpBus.request("put", `/device/v2/station/new/equipments`, { data: devices });
}


/**
 * 导出eLink配置
 * @param {*} stationUUID 电站ID
 * @param {*} eLinkId elink主键ID
 * @param {*} eBlockNum eBlock数量
 * @param {*} eBlockType eBlock型号
 * @returns 
 */
export function exportELinkConfig(stationUUID, eLinkId, eBlockNum, eBlockType) {
  return httpBus.request("put", `/device/v2/station/exportELinkConfig`, {
    data: {
      stationUUID, eLinkId, eBlockNum, eBlockType
    }
  });
}

/**
 * 参考需量查询接口
 * @returns 
 */
export function demandList(stationId, pageNum, pageSize, demand) {
  return httpBus.request("get", `/device/station/demand/list`, {
    params: {
      stationId, pageNum, pageSize, demand
    }
  });
}

/**
 *
 * @returns 
 */
export function validateStationUUID(uuid) {
  return httpBus.request("get", `/device/station/queryStationUUID`, {
    params: {
      uuid
    }
  });
}




export const v2 = Object.freeze({
  getDevicesById,
  getDevicesByIdV2,
  registerDevices,
  registerDevicesV2,
})
